import { sha256 } from 'js-sha256'
import Vue from 'vue'

export function debounce(fn, wait) {
  let timeout
  return function(...args) {
    const later = () => {
      clearTimeout(timeout)
      // eslint-disable-next-line
      fn.apply(this, args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export function capitalizeText (string) {
  return string.substring(0, 1).toUpperCase() + string.substring(1)
}

export function isJsonString (str) {
  try {
    if (!isNaN(parseFloat(str))) {
      throw new Error("it's a number");
    }

    JSON.parse(str);
  } catch (e) {
    return false
  }

  return true
}
export function getQueryParam(param) {
  const hash = window.location.search.length > 0 ? window.location.search : window.location.hash;
  const queryString = hash.includes('?') ? hash.split('?')[1] : '';
  const params = new URLSearchParams(queryString);
  return params.get(param);
}

const getServerTime = async () => {
  try {
    const response = await Vue.prototype.api.get('/get-server-time')
    if (response?.data?.timestamp) {
      return response.data.timestamp
    } else {
      console.error('Invalid server response:', response)
      return null
    }
  } catch (error) {
    console.error('Error fetching server time:', error)
    return null
  }
}

export async function getMathHeaders() {
  const mathTask = 17 + 36
  const currentTimestamp = await getServerTime()

  if (currentTimestamp === null) {
    throw new Error('Could not synchronize with server time')
  }
  const hash = sha256(`${mathTask}:${currentTimestamp}`).toString()
  return { 'X-Math-Hash': hash, 'X-Math-Timestamp': currentTimestamp }
}

export function deleteCookieWithDote(name) {
  try {
    const domain = document.domain;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}`;
  } catch (e) {
    console.error(e)
  }
}
